import React, { useEffect } from 'react';

import { encode } from 'html-entities';

import { useAppSelector } from 'hooks';
import { SurveyJS } from 'components/Surveys';
import { useAxios } from 'configs/requests';
import { Error, Loading } from 'components/Fetch';

interface IFillSurveyProps {
  surveyId: string;
  onClose: any;
  onLoad?: any;
}

const Survey = ({ surveyId, onClose, onLoad }: IFillSurveyProps) => {
  const patientId = useAppSelector(({ patient }) => patient?.data?.uid);

  const [{ data, loading, error }, getSurvey] = useAxios(
    {
      url: `/patient/Questionnaires/${surveyId}`
    },
    { useCache: false }
  );

  const [{ loading: postLoading, error: postError }, postSurvey] = useAxios(
    {
      url: `/clinician-gateway/questionnaire/${surveyId}/answer`,
      method: 'post'
    },
    { manual: true }
  );

  const handleComplete = (responses: any) => {
    const data = {
      responses,
      patientUid: patientId
    };
    for (const answerKey in responses) {
      if (typeof responses[answerKey] === 'string') {
        responses[answerKey] = encode(responses[answerKey]);
      }
    }

    postSurvey({ data }).then((response) => {
      if (response.data && !error) {
        onClose();
      }
    });
  };

  useEffect(() => {
    if (data && onLoad) {
      onLoad(data);
    }
  }, [data, onLoad]);

  return (
    <>
      {(error || postError) && <Error retry={getSurvey} dismissible={false} />}
      {loading || postLoading ? (
        <Loading dataTestId="survey-loading" />
      ) : (
        data && <SurveyJS useCustomCss={true} survey={data} handleComplete={handleComplete} />
      )}
    </>
  );
};

export default Survey;
